import React from 'react'
import Button from './Button'

/* doc
---
title: ErrorButton
name: ErrorButton
category: React - Bulma
parent: Button
---

An `ErrorButton` is a styled version of the `Button` component and should be
used when showing an error or an action that has some serious consequences.

See `Button` component for full details.

```html_example
  <ErrorButton isOutlined href="/danger-zone">
    Highway
  </ErrorButton>
```
*/
function ErrorButton(props) {
  const { children, className, ...rest } = props

  const classes = [
    'is-danger',
    className || '',
  ]

  return (
    <Button {...rest} className={classes.join(' ')}>
      {children}
    </Button>
  )
}

export default ErrorButton
